module.exports = __webpack_public_path__ + "img/creat.ded8a0dc.png";